import React from "react";
import styled, { ThemeProvider } from "styled-components";
import { GlobalStyle, lightTheme, darkTheme } from "../constants/styles";
import useAppTheme from "../hooks/useAppTheme";

const PageLayout = ({ children }) => {
  const { theme } = useAppTheme();

  return (
    <ThemeProvider theme={theme === "light" ? lightTheme : darkTheme}>
      <GlobalStyle />
      <Page>{children}</Page>
    </ThemeProvider>
  );
};

export default PageLayout;

const Page = styled.div`
  height: 100vh;
  min-height: 500px;
  display: flex;
  flex-direction: row;
`;
